import {
  editorTextBoxFacesLoaded,
  editorTextBoxFailedFamilies,
} from '@/utils/editor-text-box/editorTextBoxAdapter'
import {
  EDITOR_TEXT_FACES_FAILED_ATTR,
  EDITOR_TEXT_FIT_SETTLED_ATTR,
  EDITOR_TEXT_FIT_VERSION_ATTR,
  EDITOR_TEXT_REVEALED_ATTR,
} from '@/utils/editor/textGeometryAttributes'

/**
 * Stamps a Lotus box's fit on its root: the fit's version, and the settled
 * stamp once no fit is pending and every face the host's text draws from has
 * landed. On the pdf surface a box whose painting face failed names the
 * failed families (EDITOR_TEXT_FACES_FAILED_ATTR) and stays unsettled, and
 * the PDF worker fails the job on the name: a print never draws from a face
 * that failed. Everywhere else a failed face settles the box on its
 * fallback.
 */
export const stampEditorTextFit = (
  root: HTMLElement,
  host: HTMLElement,
  {
    version,
    fitPending,
    pdf,
  }: { version: number; fitPending: boolean; pdf: boolean },
): void => {
  root.setAttribute(EDITOR_TEXT_FIT_VERSION_ATTR, String(version))
  const failed = pdf ? editorTextBoxFailedFamilies(host) : []
  if (failed.length > 0)
    root.setAttribute(EDITOR_TEXT_FACES_FAILED_ATTR, failed.join(', '))
  else root.removeAttribute(EDITOR_TEXT_FACES_FAILED_ATTR)
  if (failed.length === 0 && !fitPending && editorTextBoxFacesLoaded(host)) {
    root.setAttribute(EDITOR_TEXT_FIT_SETTLED_ATTR, 'true')
    root.setAttribute(EDITOR_TEXT_REVEALED_ATTR, 'true')
  } else root.removeAttribute(EDITOR_TEXT_FIT_SETTLED_ATTR)
}
